<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar cliente"
  [style]="{ width: '600px', height: '500px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-6">
            <label class="label-required">Tipo de documento</label>
            <p-dropdown
              [options]="typesDocument"
              formControlName="identifierId"
              placeholder="Selecciona un tipo de documento"
              optionLabel="name"
              optionValue="id"
              [virtualScroll]="true"
              [itemSize]="5"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('identifierId').invalid &&
                (fg.get('identifierId').dirty || fg.get('identifierId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('identifierId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label class="label-required">N° de documento</label>
            <input
              pInputText
              formControlName="idNumber"
              type="text"
              pattern="[0-9]*"
            />
            <div
              *ngIf="
                fg.get('idNumber').invalid &&
                (fg.get('idNumber').dirty || fg.get('idNumber').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('idNumber').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('idNumber').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 8.</small
                >
              </div>
              <div *ngIf="fg.get('idNumber').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 11.</small
                >
              </div>
              <div *ngIf="fg.get('idNumber').errors?.pattern">
                <small class="p-error">Debe ingresar solo números.</small>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Tipo de persona</label>
            <p-dropdown
              [options]="typesTypeDocument"
              formControlName="typeId"
              placeholder="Selecciona un tipo de persona"
              optionLabel="name"
              optionValue="id"
              dataKey="id"
              [virtualScroll]="true"
              [itemSize]="5"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('typeId').invalid &&
                (fg.get('typeId').dirty || fg.get('typeId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('typeId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Fidelidad</label>
            <p-dropdown
              [options]="typeDocumentGroupLoyalty"
              formControlName="groupLoyaltyId"
              placeholder="Selecciona el grado de fidelidad"
              optionLabel="name"
              optionValue="id"
              dataKey="id"
              [virtualScroll]="true"
              [itemSize]="5"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('groupLoyaltyId').invalid &&
                (fg.get('groupLoyaltyId').dirty ||
                  fg.get('groupLoyaltyId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('groupLoyaltyId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label class="label-required">Nombre</label>
            <input
              pInputText
              formControlName="name"
              type="text"
              pattern="[^0-9]*"
            />
            <div
              *ngIf="
                fg.get('name').invalid &&
                (fg.get('name').dirty || fg.get('name').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('name').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('name').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('name').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 255.</small
                >
              </div>
              <div *ngIf="fg.get('name').errors?.pattern">
                <small class="p-error">Debe ingresar solo a-z,A-Z</small>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label>Dirección</label>
            <input pInputText formControlName="address" type="text" />
            <div
              *ngIf="
                fg.get('address').invalid &&
                (fg.get('address').dirty || fg.get('address').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('address').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('address').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('address').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Teléfono</label>
            <input
              pInputText
              formControlName="phone"
              type="text"
              pattern="[0-9]*"
            />
            <div
              *ngIf="
                fg.get('phone').invalid &&
                (fg.get('phone').dirty || fg.get('phone').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('phone').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('phone').errors?.minlength">
                <small class="p-error">Debe tener una longitud de 9.</small>
              </div>
              <div *ngIf="fg.get('phone').errors?.maxlength">
                <small class="p-error">Excedio su longitud de 9.</small>
              </div>
              <div *ngIf="fg.get('phone').errors?.pattern">
                <small class="p-error"
                  >Debe ingresar solo números entre 0-9..</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Email</label>
            <input
              pInputText
              formControlName="email"
              type="text"
              pattern="[^@]{1,255}@[^@,^.]{1,255}.[^@,^.]{1,255}"
              placeholder="example@gmail.com"
            />
            <div
              *ngIf="
                fg.get('email').invalid &&
                (fg.get('email').dirty || fg.get('email').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('email').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('email').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximma de 255.</small
                >
              </div>
              <div *ngIf="fg.get('email').errors?.pattern">
                <small class="p-error"
                  >Email is invalido (example@gmail.com) !</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
